import * as XLSX from 'xlsx';
import mammoth from 'mammoth';

/* ==========================================================
   BỘ QUY TẮC TRỪ GIÁ — Theo bảng chuẩn kế toán Thế Thảo Pharma
   heSo: Phần trăm giá trị được trừ vào giá nhập (100%, 70%, 60%, 0%).
   nhom: Phân loại theo tính chất thời điểm và hình thức.
   ========================================================== */
export const CTKM_RULES = {
  CTKM01: {
    ma: 'CTKM01',
    ten: 'Tặng hàng cùng loại (bonus cùng SKU)',
    heSo: 100,
    nhom: 'soLuong',
    nhomTen: 'Hàng tặng cùng loại',
    moTa: 'Trừ 100% bằng cách cộng dồn vào số lượng nhận (chia giá theo tổng số hộp nhận).',
  },
  CTKM02: {
    ma: 'CTKM02',
    ten: 'Tặng hàng khác loại (bán được)',
    heSo: 100,
    nhom: 'ngay',
    nhomTen: 'Hàng tặng bán tốt',
    moTa: 'Hàng tặng bán được chạy, quy đổi 100% giá trị để trừ vào tiền hàng.',
  },
  CTKM03: {
    ma: 'CTKM03',
    ten: 'Tặng hàng khác loại (hàng mới, cận date)',
    heSo: 0,
    nhom: 'ngay',
    nhomTen: 'Hàng tặng rủi ro',
    moTa: 'Hàng mới chưa rõ sức bán, hoặc hàng cận date có rủi ro tồn kho: Không được trừ vào giá (0%).',
  },
  CTKM04: {
    ma: 'CTKM04',
    ten: 'Chiết khấu trực tiếp trên hóa đơn',
    heSo: 100,
    nhom: 'hoaDon',
    nhomTen: 'Chiết khấu hóa đơn',
    moTa: 'Trừ thẳng trực tiếp khi thanh toán đơn hàng, chắc chắn nhận được 100%.',
  },
  CTKM05: {
    ma: 'CTKM05',
    ten: 'Giảm giá theo combo / thùng / lô',
    heSo: 100,
    nhom: 'hoaDon',
    nhomTen: 'Giảm giá combo / lô',
    moTa: 'Chiết khấu trừ ngay khi đạt số lượng đóng gói hoặc combo nguyên lô.',
  },
  CTKM06: {
    ma: 'CTKM06',
    ten: 'Flash sale / ngày vàng / giá sốc',
    heSo: 100,
    nhom: 'hoaDon',
    nhomTen: 'Giá sốc / Ngày vàng',
    moTa: 'Giảm giá trực tiếp theo sự kiện ngắn hạn của nhà cung cấp.',
  },
  CTKM07: {
    ma: 'CTKM07',
    ten: 'Voucher trừ tiền của chính hãng',
    heSo: 100,
    nhom: 'ngay',
    nhomTen: 'Voucher chính hãng',
    moTa: 'Voucher trừ tiền hàng thật của chính nhà cung cấp cho các đơn kế tiếp.',
  },
  CTKM08: {
    ma: 'CTKM08',
    ten: 'Trừ tiền trực tiếp vào công nợ / đơn tháng sau',
    heSo: 100,
    nhom: 'ngay',
    nhomTen: 'Trừ công nợ',
    moTa: 'Khoản giảm trừ thực tế ghi nhận giảm công nợ thanh toán kỳ sau.',
  },
  CTKM09: {
    ma: 'CTKM09',
    ten: 'Chiết khấu cuối kỳ (rebate)',
    heSo: 100,
    nhom: 'cuoiKy',
    nhomTen: 'Rebate cuối kỳ',
    moTa: 'Khoản chiết khấu thương mại trả lại bằng tiền hoặc cấn trừ sau khi nghiệm thu hợp đồng.',
  },
  CTKM10: {
    ma: 'CTKM10',
    ten: 'Thưởng doanh số tháng / quý / năm',
    heSo: 100,
    nhom: 'cuoiKy',
    nhomTen: 'Thưởng doanh số',
    moTa: 'Thưởng đạt chỉ tiêu doanh thu thực nhận, chỉ có khi đạt ngưỡng cam kết.',
  },
  CTKM11: {
    ma: 'CTKM11',
    ten: 'Thưởng tăng trưởng / mở mới',
    heSo: 0,
    nhom: 'cuoiKy',
    nhomTen: 'Thưởng tăng trưởng',
    moTa: 'Chỉ tiêu tăng trưởng không chắc chắn, không nên tính sẵn vào giá vốn (0%).',
  },
  CTKM12: {
    ma: 'CTKM12',
    ten: 'Tặng quà vật dụng nhỏ',
    heSo: 0,
    nhom: 'qua',
    nhomTen: 'Quà lưu niệm / nhỏ',
    moTa: 'Áo mưa, mũ bảo hiểm, cốc, bút, sổ tay: Không quy đổi ra tiền hàng (0%).',
  },
  CTKM13: {
    ma: 'CTKM13',
    ten: 'Tặng POSM / kệ / biển bảng',
    heSo: 0,
    nhom: 'qua',
    nhomTen: 'POSM / Kệ biển',
    moTa: 'Vật dụng trưng bày quảng bá cho thương hiệu hãng: Không làm giảm giá nhập (0%).',
  },
  CTKM14: {
    ma: 'CTKM14',
    ten: 'Voucher mua hàng siêu thị / bên thứ ba',
    heSo: 70,
    nhom: 'qua',
    nhomTen: 'Voucher bên thứ 3',
    moTa: 'Voucher Got It, Coop, VinID, xăng xe...: Tính 70% giá trị theo giá thị trường sang nhượng.',
  },
  CTKM15: {
    ma: 'CTKM15',
    ten: 'Tặng vàng',
    heSo: 100,
    nhom: 'qua',
    nhomTen: 'Hiện vật vàng',
    moTa: 'Vàng miếng, chỉ vàng PNJ / SJC: Tính 100% giá trị quy đổi tương đương tiền mặt.',
  },
  CTKM16: {
    ma: 'CTKM16',
    ten: 'Tặng hiện kim, xe máy',
    heSo: 70,
    nhom: 'qua',
    nhomTen: 'Hiện vật giá trị lớn',
    moTa: 'Xe máy, điện thoại, tivi, tủ lạnh...: Tính 70% sau khi trừ chi phí đăng ký / thanh lý.',
  },
  CTKM17: {
    ma: 'CTKM17',
    ten: 'Du lịch tích điểm tri ân',
    heSo: 60,
    nhom: 'qua',
    nhomTen: 'Du lịch tri ân',
    moTa: 'Tour du lịch nghỉ dưỡng tri ân: Tính 60% theo giá trị thực tế trải nghiệm hoặc sang nhượng vé.',
  },
  CTKM18: {
    ma: 'CTKM18',
    ten: 'Du lịch chạy (nâng giá để được tính)',
    heSo: 60,
    nhom: 'qua',
    nhomTen: 'Du lịch chạy số',
    moTa: 'Tour du lịch ép chỉ tiêu nâng giá: Tính 60% theo nguyên tắc thận trọng kế toán.',
  },
  CTKM19: {
    ma: 'CTKM19',
    ten: 'Hỗ trợ marketing / activation',
    heSo: 0,
    nhom: 'qua',
    nhomTen: 'Hỗ trợ marketing',
    moTa: 'Kinh phí tổ chức sự kiện hoặc quảng cáo của hãng: Không trừ vào giá vốn (0%).',
  },
  CTKM20: {
    ma: 'CTKM20',
    ten: 'Hỗ trợ trưng bày / listing / thuê vị trí',
    heSo: 0,
    nhom: 'qua',
    nhomTen: 'Hỗ trợ trưng bày',
    moTa: 'Tiền thuê diện tích quầy, bản chất là bù đắp mặt bằng: Không trừ vào giá sản phẩm (0%).',
  },
};

export function getRule(ma) {
  if (!ma) return { ten: 'Khoản khác', heSo: 0, nhom: 'qua', nhomTen: 'Khác', moTa: 'Chưa phân loại' };
  const cleanMa = String(ma).toUpperCase().trim().replace(/[^A-Z0-9]/g, '');
  return CTKM_RULES[cleanMa] || { ten: 'Khoản khác', heSo: 0, nhom: 'qua', nhomTen: 'Khác', moTa: 'Chưa phân loại' };
}

/* ==========================================================
   TIỆN ÍCH ĐỊNH DẠNG SỐ & TIỀN TỆ
   ========================================================== */
export function fmt(n, d = 1) {
  const val = Number(n);
  return (isFinite(val) ? val : 0).toLocaleString('vi-VN', {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });
}

export function vnd(n) {
  const val = Number(n);
  return Math.round(isFinite(val) ? val : 0).toLocaleString('vi-VN');
}

export function pc(n, d = 1) {
  return `${fmt(n, d)}%`;
}

export function r0(n) {
  const val = Number(n);
  return Math.round(isFinite(val) ? val : 0);
}

export function num(v, fallback = 0) {
  if (typeof v === 'number' && isFinite(v)) return v;
  if (!v) return fallback;
  const str = String(v)
    .trim()
    .replace(/[^0-9.,-]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const parsed = parseFloat(str);
  return isFinite(parsed) ? parsed : fallback;
}

/* ==========================================================
   DỮ LIỆU MẪU CHUẨN (Kiểm thử bản 3 trong tài liệu kỹ thuật)
   ========================================================== */
export const SAMPLE_PROMOTION_DATA = {
  tenCT: 'Chương trình mẫu tháng 9 — Hãng ABC',
  ncc: 'Công ty Dược phẩm ABC',
  uuDaiCongBo: 30,
  ckDon: 10,
  ckThang: 3,
  ckQuy: 2,
  sanPham: [
    {
      ten: 'Sản phẩm A',
      quyCach: 'Hộp 10 vỉ x 10 viên',
      giaNiemYet: 120000,
      slMua: 1500,
      slTang: 150,
      ckDong: 0,
    },
    {
      ten: 'Sản phẩm B',
      quyCach: 'Chai 100ml',
      giaNiemYet: 250000,
      slMua: 200,
      slTang: 0,
      ckDong: 5,
    },
    {
      ten: 'Sản phẩm C',
      quyCach: 'Hộp 30 viên',
      giaNiemYet: 55000,
      slMua: 800,
      slTang: 80,
      ckDong: 0,
    },
  ],
  khoanThem: [
    {
      ten: 'Chuyến du lịch Đà Nẵng',
      maCTKM: 'CTKM17',
      giaTri: 20000000,
      quyDoi: null,
    },
    {
      ten: 'Bộ kệ trưng bày tại quầy',
      maCTKM: 'CTKM13',
      giaTri: 3000000,
      quyDoi: null,
    },
  ],
};

/* ==========================================================
   TRẠNG THÁI RỖNG — Dùng khi chưa phân tích được chương trình nào
   (KHÔNG dùng dữ liệu mẫu để tránh gây hiểu nhầm là kết quả thật)
   ========================================================== */
export const EMPTY_PROMOTION_DATA = {
  tenCT: '',
  ncc: '',
  uuDaiCongBo: null,
  ckDon: 0,
  ckThang: 0,
  ckQuy: 0,
  ckThangBac: [],
  ckQuyBac: [],
  sanPham: [],
  khoanThem: [],
};

/* ==========================================================
   BẬC THƯỞNG DOANH SỐ (ckThangBac / ckQuyBac)
   Mỗi bậc: { tu: doanh số tối thiểu (đồng), den: doanh số tối đa (đồng) hoặc null nếu không giới hạn, tyLe: % thưởng }
   ========================================================== */

// Tìm bậc thưởng khớp với doanh số ước tính người dùng nhập, null nếu không khớp bậc nào
export function findTierInfo(bacArr, revenue) {
  const rev = num(revenue, 0);
  if (!Array.isArray(bacArr) || !bacArr.length || rev <= 0) return null;
  const sorted = [...bacArr].sort((a, b) => num(a.tu) - num(b.tu));
  for (const tier of sorted) {
    const tu = num(tier.tu);
    const den = tier.den === null || tier.den === undefined || tier.den === '' ? null : num(tier.den);
    if (rev >= tu && (den === null || rev < den)) return tier;
  }
  return null;
}

// Trả về % thưởng áp dụng: khớp đúng bậc theo doanh số nhập vào, hoặc dùng tỷ lệ mặc định (fallbackRate) nếu
// chưa nhập doanh số / không có bảng bậc / doanh số chưa đạt bậc thấp nhất
export function resolveTieredRate(bacArr, revenue, fallbackRate) {
  const rev = num(revenue, 0);
  if (!Array.isArray(bacArr) || !bacArr.length || rev <= 0) return fallbackRate;
  const tier = findTierInfo(bacArr, revenue);
  if (tier) return num(tier.tyLe, fallbackRate);
  // Đã nhập doanh số nhưng chưa đạt tới bậc thấp nhất -> chưa được hưởng thưởng nào
  const sorted = [...bacArr].sort((a, b) => num(a.tu) - num(b.tu));
  if (rev < num(sorted[0].tu)) return 0;
  return fallbackRate;
}

/* ==========================================================
   LÕI TÍNH TOÁN 5 NGƯỠNG — CHUẨN KẾ TOÁN
   ========================================================== */
export function tinhGiaNhapThat(ct = {}) {
  const r = {
    tenCT: ct.tenCT || 'Chương trình khuyến mãi',
    ncc: ct.ncc || '',
    uuDaiCongBo: ct.uuDaiCongBo === undefined || ct.uuDaiCongBo === null ? null : num(ct.uuDaiCongBo),
    ckDon: Math.min(99, Math.max(0, num(ct.ckDon))),
    ckThang: Math.min(99, Math.max(0, num(ct.ckThang))),
    ckQuy: Math.min(99, Math.max(0, num(ct.ckQuy))),
    sp: [],
    khoan: [],
  };

  // 1. Xử lý các khoản kèm theo, áp bộ quy tắc trừ giá của kế toán
  r.quaTien = 0;
  r.quaHangBao = 0;
  r.khongTru = [];
  r.khongTruTien = 0;

  // 1. Xử lý từng sản phẩm và tính tổng hóa đơn (slMua mặc định >= 1 để tính đơn giá chuẩn xác)
  let MB = 0; // Tổng niêm yết hàng mua
  let MT = 0; // Tổng niêm yết hàng tặng cùng loại
  let M1 = 0; // Tổng tiền hóa đơn sau chiết khấu dòng & chiết khấu đơn

  (ct.sanPham || []).forEach((s) => {
    const rawSlMua = num(s.slMua);
    const slTang = Math.max(0, num(s.slTang));
    // Nếu bảng giá chung không set slMua hoặc AI trả về 0, mặc định là 1 để quy đổi đơn giá
    const slMua = rawSlMua > 0 ? rawSlMua : 1;

    const thueVAT = Math.max(0, num(s.thueVAT));
    const giaChuaVAT = Math.max(0, num(s.giaChuaVAT));
    let G0 = Math.max(0, num(s.giaNiemYet));

    // Nếu có thuế VAT nhưng giá niêm yết bằng đúng giá chưa VAT -> tự động tính thuế vào G0
    if (thueVAT > 0 && giaChuaVAT > 0 && G0 === giaChuaVAT) {
      G0 = Math.round(giaChuaVAT * (1 + thueVAT / 100));
    }

    const ckD = Math.min(99, Math.max(0, num(s.ckDong)));
    const G1 = G0 * (1 - ckD / 100) * (1 - r.ckDon / 100);
    const tienHD = slMua * G1;
    MB += slMua * G0;
    MT += slTang * G0;
    M1 += tienHD;

    r.sp.push({
      ten: s.ten || '',
      quyCach: s.quyCach || '',
      giaChuaVAT: giaChuaVAT > 0 ? giaChuaVAT : (thueVAT > 0 ? Math.round(G0 / (1 + thueVAT / 100)) : G0),
      thueVAT: thueVAT,
      G0: G0,
      slMua: slMua,
      slTang: slTang,
      slNhan: slMua + slTang,
      ckDong: ckD,
      G1: G1,
      tienHD: tienHD,
    });
  });

  r.M0 = MB + MT;
  r.tongHoaDon = M1;

  // 2. Xử lý các khoản kèm theo (hỗ trợ cả quà hiện vật và chiết khấu % phụ)
  (ct.khoanThem || []).forEach((k) => {
    let gt = Math.max(0, num(k.giaTri));
    const ru = getRule(k.maCTKM);
    let hs =
      k.quyDoi === undefined || k.quyDoi === null || k.quyDoi === ''
        ? ru.heSo
        : Math.min(100, Math.max(0, num(k.quyDoi)));

    // Nếu khoản kèm theo là dạng chiết khấu % hóa đơn (ví dụ CTKM04 chiết khấu 6% đơn phát sinh):
    if (gt === 0 && hs > 0 && M1 > 0) {
      gt = (M1 * hs) / 100;
      hs = 100; // Chiết khấu hóa đơn thì 100% được trừ vào giá
    }

    const tien = (gt * hs) / 100;
    const item = {
      ten: k.ten || ru.ten,
      ma: k.maCTKM || ru.ma,
      ruleTen: ru.ten,
      nhomTen: ru.nhomTen,
      giaTri: gt,
      heSo: hs,
      tien: tien,
    };
    r.khoan.push(item);
    r.quaHangBao += gt;
    if (hs > 0) {
      r.quaTien += tien;
    } else {
      r.khongTru.push(item);
      r.khongTruTien += gt;
    }
  });

  // 3. Phân bổ các ngưỡng xuống từng sản phẩm
  r.sp.forEach((x) => {
    const tyTrong = M1 > 0 ? x.tienHD / M1 : 0;
    x.tyTrong = tyTrong;
    x.G2 = x.slNhan > 0 ? x.tienHD / x.slNhan : x.G1;
    x.G3 = x.G2 * (1 - r.ckThang / 100);
    x.G4 = x.G3 * (1 - r.ckQuy / 100);
    x.G5 = x.slNhan > 0 ? x.G4 - (r.quaTien * tyTrong) / x.slNhan : x.G4;

    x.ck1 = x.G0 > 0 ? (1 - x.G1 / x.G0) * 100 : 0;
    x.ck2 = x.G0 > 0 ? (1 - x.G2 / x.G0) * 100 : 0;
    x.ck3 = x.G0 > 0 ? (1 - x.G3 / x.G0) * 100 : 0;
    x.ck4 = x.G0 > 0 ? (1 - x.G4 / x.G0) * 100 : 0;
    x.ck5 = x.G0 > 0 ? (1 - x.G5 / x.G0) * 100 : 0;
  });

  // 4. Bảng 5 tầng ngưỡng cấp chương trình
  const M3 = M1 * (1 - r.ckThang / 100);
  const M4 = M3 * (1 - r.ckQuy / 100);
  const M5 = M4 - r.quaTien;
  const d = r.M0 > 0 ? r.M0 : 1;

  r.lop = {
    hoaDon: ((MB - M1) / d) * 100,
    hangTang: (MT / d) * 100,
    ckThang: ((M1 - M3) / d) * 100,
    ckQuy: ((M3 - M4) / d) * 100,
    qua: (r.quaTien / d) * 100,
  };

  r.nguong = [
    {
      id: 1,
      ten: 'Chiết khấu ghi trên hóa đơn',
      ck: ((MB - M1) / d) * 100,
      tien: M1,
      giai: r.ckDon > 0
        ? `Trừ thẳng khi mua, hãng ghi ${pc(r.ckDon)}`
        : 'Chương trình không có chiết khấu thẳng trên đơn',
    },
    {
      id: 2,
      ten: 'Cộng hàng tặng cùng loại',
      ck: (MT / d) * 100,
      tien: M1,
      giai: MT > 0
        ? 'Nhận thêm hàng, không phải trả thêm tiền'
        : 'Chương trình không có hàng tặng cùng loại',
    },
    {
      id: 3,
      ten: 'Đạt thưởng doanh số tháng',
      ck: ((M1 - M3) / d) * 100,
      tien: M3,
      giai: r.ckThang > 0
        ? `Hãng ghi ${pc(r.ckThang)} trên tiền hàng sau khi đạt chỉ tiêu tháng`
        : 'Chương trình không có thưởng tháng',
    },
    {
      id: 4,
      ten: 'Đạt thưởng doanh số quý',
      ck: ((M3 - M4) / d) * 100,
      tien: M4,
      giai: r.ckQuy > 0
        ? `Hãng ghi ${pc(r.ckQuy)} trên tiền hàng sau khi đạt chỉ tiêu quý`
        : 'Chương trình không có thưởng quý',
    },
    {
      id: 5,
      ten: 'Cộng các khoản kèm theo được trừ giá',
      ck: (r.quaTien / d) * 100,
      tien: M5,
      giai: r.quaHangBao > 0
        ? `Hãng báo ${vnd(r.quaHangBao)}đ, theo kế toán quy đổi trừ được ${vnd(r.quaTien)}đ`
        : 'Chương trình không có khoản kèm theo',
    },
  ];

  let cong = 0;
  r.nguong.forEach((n) => {
    cong += n.ck;
    n.congDon = cong;
  });

  r.tongCK = cong;
  r.ckTrenHoaDon = ((r.M0 - M1) / d) * 100;
  r.ngoaiHoaDon = r.M0 - M5 > 0 ? ((M1 - M5) / (r.M0 - M5)) * 100 : 0;
  r.chenhCongBo = r.uuDaiCongBo === null ? null : r.uuDaiCongBo - r.tongCK;

  return r;
}

/* ==========================================================
   BỘ TẠO CẢNH BÁO RỦI RO CHUYÊN SÂU
   ========================================================== */
export function taoCanhBaoCTKM(r) {
  const a = [];

  // 1. Hãng công bố cao hơn tổng ngưỡng > 7 điểm
  if (r.chenhCongBo !== null && r.chenhCongBo > 7) {
    a.push({
      type: 'bad',
      icon: '!',
      title: `Hãng nói ${pc(r.uuDaiCongBo)} nhưng cộng hết các ngưỡng chỉ ${pc(r.tongCK)}`,
      desc: `Chênh lệch ${fmt(r.chenhCongBo, 1)} điểm phần trăm. Khi đàm phán, hãy hỏi thẳng phần nào ghi trên hóa đơn và phần nào phải đạt điều kiện chỉ tiêu mới có.`,
    });
  }

  // 2. Thưởng tháng + quý > 0
  const traSau = (r.lop?.ckThang || 0) + (r.lop?.ckQuy || 0);
  if (traSau > 0.05) {
    a.push({
      type: 'warn',
      icon: '%',
      title: `Có ${pc(traSau)} chỉ nhận được nếu đạt đủ chỉ tiêu doanh số`,
      desc: `Thưởng tháng ${pc(r.ckThang)} và thưởng quý ${pc(r.ckQuy)} nằm ở ngưỡng phải đạt mới có. Nếu tháng nào hụt chỉ tiêu là mất phần đó — đừng tính sẵn vào giá bán ra. Hãy hỏi rõ mốc doanh số cụ thể trước khi chốt đơn.`,
    });
  }

  // 3. Có khoản CTKM hệ số 0%
  if (r.khongTru?.length) {
    a.push({
      type: 'bad',
      icon: '✕',
      title: `${r.khongTru.length} khoản không được trừ vào giá vốn, tổng ${vnd(r.khongTruTien)}đ`,
      desc: `${r.khongTru.map((k) => `${k.ten} (${k.ruleTen.toLowerCase()})`).join('; ')}. Theo quy tắc kế toán, những khoản này không làm giảm giá nhập — nghe thì to nhưng không vào túi bạn dưới dạng tiền hàng.`,
    });
  }

  // 4. Quà bị chiết bớt khi quy đổi ra tiền
  const quaHut = r.quaHangBao - r.quaTien - r.khongTruTien;
  if (quaHut > 0.5) {
    a.push({
      type: 'warn',
      icon: '₫',
      title: `Có ${vnd(quaHut)}đ giá trị quà bị chiết bớt khi quy ra tiền`,
      desc: `Theo quy tắc kế toán thực chiến: Du lịch trừ 60% giá hãng báo; Voucher bên thứ ba và xe máy/hiện kim trừ 70%; Vàng trừ 100%. Nếu bạn thanh lý hoặc bán lại được giá tốt hơn, hãy cập nhật mức quy đổi thực tế.`,
    });
  }

  // 5. Tỷ lệ ngoài hóa đơn cao
  if (r.ngoaiHoaDon > 60) {
    a.push({
      type: 'bad',
      icon: '%',
      title: `${fmt(r.ngoaiHoaDon, 0)}% chiết khấu không nằm trên hóa đơn`,
      desc: `Phần lớn cái lợi nằm ở thưởng phải đạt và quà tặng. Nếu không đạt chỉ tiêu, chiết khấu thật bạn cầm chắc chỉ còn ${pc(r.ckTrenHoaDon)}.`,
    });
  } else if (r.ngoaiHoaDon > 45) {
    a.push({
      type: 'warn',
      icon: '%',
      title: `${fmt(r.ngoaiHoaDon, 0)}% chiết khấu không nằm trên hóa đơn`,
      desc: `Gần một nửa giá trị phụ thuộc vào thưởng sau và quà tặng. Nên thương thảo xin nhà cung cấp chuyển bớt sang chiết khấu thẳng trên hóa đơn — vừa dễ kiểm soát vừa không rủi ro.`,
    });
  }

  // 6. Tổng chiết khấu mỏng
  if (r.tongCK < 8 && r.sp?.length) {
    a.push({
      type: 'warn',
      icon: '%',
      title: `Cộng hết các ngưỡng mới được ${pc(r.tongCK)}`,
      desc: `Mức chiết khấu này mỏng so với mặt bằng chương trình ngành dược. Nếu không phải hàng độc quyền hoặc hàng chạy quảng cáo mạnh, nên cân nhắc tham khảo thêm nhà cung cấp khác.`,
    });
  }

  // 7. Chương trình sạch sẽ
  if (a.length === 0) {
    a.push({
      type: 'good',
      icon: '✓',
      title: 'Chương trình sạch sẽ, không có điểm gợn rủi ro',
      desc: `Chiết khấu chủ yếu nằm ngay trên hóa đơn, không phụ thuộc vào áp lực thưởng doanh số hay quà tặng khó quy đổi. Đây là dạng chương trình tối ưu và an toàn nhất cho quầy.`,
    });
  }

  return a;
}

/* ==========================================================
   XUẤT EXCEL 1 SHEET "Chi tiết từng mã" 19 CỘT CHUẨN CHỈ
   ========================================================== */
export const EXCEL_COLUMNS = [
  'STT',
  'Tên sản phẩm',
  'Quy cách',
  'Nguyên giá (Chưa VAT)',
  'Thuế VAT (%)',
  'Giá niêm yết (Đã gồm VAT)',
  'SL mua',
  'SL tặng',
  'SL nhận',
  'CK trên hóa đơn (%)',
  'Giá sau CK hóa đơn',
  'CK cộng dồn sau hàng tặng (%)',
  'Giá sau hàng tặng',
  'CK cộng dồn sau thưởng tháng (%)',
  'Giá sau thưởng tháng',
  'CK cộng dồn sau thưởng quý (%)',
  'Giá sau thưởng quý',
  'CK cộng dồn sau quà (%)',
  'GIÁ NHẬP CUỐI',
];

export function buildExcelRow(x, index) {
  return [
    index + 1,
    x.ten,
    x.quyCach,
    r0(x.giaChuaVAT || x.G0),
    x.thueVAT > 0 ? `${x.thueVAT}%` : '0%',
    r0(x.G0),
    x.slMua,
    x.slTang,
    x.slNhan,
    +x.ck1.toFixed(2),
    r0(x.G1),
    +x.ck2.toFixed(2),
    r0(x.G2),
    +x.ck3.toFixed(2),
    r0(x.G3),
    +x.ck4.toFixed(2),
    r0(x.G4),
    +x.ck5.toFixed(2),
    r0(x.G5),
  ];
}

export function generatePromotionExcel(r) {
  const wb = XLSX.utils.book_new();
  const aoa = [EXCEL_COLUMNS];

  (r.sp || []).forEach((x, i) => {
    aoa.push(buildExcelRow(x, i));
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  // Căn chỉnh độ rộng cột tối ưu
  ws['!cols'] = [
    { wch: 6 },  // STT
    { wch: 34 }, // Tên sản phẩm
    { wch: 20 }, // Quy cách
    { wch: 18 }, // Nguyên giá (Chưa VAT)
    { wch: 14 }, // Thuế VAT (%)
    { wch: 20 }, // Giá niêm yết (Đã gồm VAT)
    { wch: 10 }, // SL mua
    { wch: 10 }, // SL tặng
    { wch: 10 }, // SL nhận
    { wch: 18 }, // CK trên HĐ
    { wch: 16 }, // Giá sau CK HĐ
    { wch: 19 }, // CK sau hàng tặng
    { wch: 16 }, // Giá sau hàng tặng
    { wch: 19 }, // CK sau thưởng tháng
    { wch: 16 }, // Giá sau thưởng tháng
    { wch: 19 }, // CK sau thưởng quý
    { wch: 16 }, // Giá sau thưởng quý
    { wch: 19 }, // CK sau quà
    { wch: 18 }, // GIÁ NHẬP CUỐI
  ];

  // Freeze 1 dòng tiêu đề và 2 cột đầu
  ws['!freeze'] = { xSplit: 2, ySplit: 1 };

  XLSX.utils.book_append_sheet(wb, ws, 'Chi tiết từng mã');

  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([out], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const rawName = (r.tenCT || 'chuong-trinh')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

  const fileName = `gia-nhap-that_${rawName || 'chuong-trinh'}.xlsx`.slice(0, 60);

  return { blob, fileName };
}

export function buildTsvClipboard(r) {
  const rows = [EXCEL_COLUMNS.join('\t')];
  (r.sp || []).forEach((x, i) => {
    rows.push(buildExcelRow(x, i).join('\t'));
  });
  return rows.join('\n');
}

/* ==========================================================
/* ==========================================================
   BỘ ĐỌC VÀ BÓC TÁCH FILE EXCEL TRỰC TIẾP (.xlsx, .xls, .csv)
   Trích xuất trực tiếp từ bảng tính, xử lý 100% chính xác cả file 500+ mã
   ========================================================== */
export function parseExcelPromotionWorkbook(wb) {
  let bestSheet = null;
  let maxRows = 0;

  // 1. Tìm sheet chứa bảng giá khuyến mãi chính
  for (const name of wb.SheetNames) {
    if (/^sheet\d+$/i.test(name)) continue;
    const ws = wb.Sheets[name];
    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
    if (data.length > maxRows) {
      maxRows = data.length;
      bestSheet = name;
    }
  }

  if (!bestSheet) bestSheet = wb.SheetNames[0];
  const ws = wb.Sheets[bestSheet];
  const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

  // 2. Định vị header row & các cột quan trọng
  let headerRowIdx = -1;
  const colMap = {};
  for (let i = 0; i < Math.min(30, data.length); i++) {
    const row = data[i] || [];
    const rowStr = row.map((c) => String(c || '').toLowerCase()).join(' | ');
    if (
      /tên sản phẩm|tên hàng|product's name|tên thuốc|mshh|quy cách/i.test(rowStr) &&
      /giá|đơn giá|price|nguyên giá/i.test(rowStr)
    ) {
      headerRowIdx = i;
      row.forEach((col, cIdx) => {
        const c = String(col || '').toLowerCase();
        if (/tên sản phẩm|product's name|tên hàng|tên sp|tên thuốc/i.test(c)) colMap.ten = cIdx;
        else if (/quy cách|đvt|đơn vị/i.test(c)) colMap.quyCach = cIdx;
        else if (/nguyên giá|giá niêm yết|giá bán|price|giá chưa vat/i.test(c)) colMap.gia = cIdx;
        else if (/^thuế$|^vat$|thuế\s*gtgt|tax/i.test(c) || /thue/i.test(c)) colMap.thue = cIdx;
        else if (/ck\s*\d+%|giá trên hóa đơn/i.test(c)) colMap.giaHD = cIdx;
        else if (/km\b|khuyến mãi/i.test(c) && !/giá km/i.test(c)) colMap.km = cIdx;
        else if (/giá km/i.test(c)) colMap.giaKM = cIdx;
      });
      break;
    }
  }

  // 3. Đọc thông tin hãng & chiết khấu tổng quát từ phần đầu file
  let ncc = '';
  let tenCT = `Bảng giá ${bestSheet}`;
  let ckDon = 0;
  let ckThang = 0;
  let ckQuy = 0;

  for (let i = 0; i < Math.max(headerRowIdx, 1); i++) {
    const rowStr = (data[i] || []).map((c) => String(c || '').trim()).filter(Boolean).join(' - ');
    if (/dược hậu giang|dhg|công ty|hãng|cp dược/i.test(rowStr) && !ncc) {
      ncc = rowStr.replace(/cộng hòa xã hội.*$/i, '').replace(/[-–\s]+$/, '').trim();
    }
    if (/thông báo|bảng giá|chương trình|tb-/i.test(rowStr) && tenCT.startsWith('Bảng giá')) {
      tenCT = rowStr.replace(/độc lập.*$/i, '').replace(/cộng hòa.*$/i, '').replace(/[-–\s]+$/, '').trim();
    }
  }

  // 4. Đọc chiết khấu từ tên cột header
  if (headerRowIdx >= 0) {
    const headerStr = (data[headerRowIdx] || []).join(' ');
    const mCKDon = headerStr.match(/(?:ck|chiết khấu)\s*(\d+(?:[.,]\d+)?)\s*%/i);
    if (mCKDon) ckDon = parseFloat(mCKDon[1].replace(',', '.'));

    const mCKThang = headerStr.match(/(?:clb|tháng).*?ck\s*(\d+(?:[.,]\d+)?)\s*%/i);
    if (mCKThang) ckThang = parseFloat(mCKThang[1].replace(',', '.'));

    const mCKQuy = headerStr.match(/(?:hthđ|quý).*?ck\s*(\d+(?:[.,]\d+)?)\s*%/i);
    if (mCKQuy) ckQuy = parseFloat(mCKQuy[1].replace(',', '.'));
  }

  // 5. Trích xuất danh sách sản phẩm (hỗ trợ phân nhóm "Mua X tặng Y")
  const sanPham = [];
  let currentGroupBonus = { slMua: 1, slTang: 0 };

  if (headerRowIdx >= 0 && colMap.ten !== undefined) {
    for (let i = headerRowIdx + 1; i < data.length; i++) {
      const row = data[i] || [];
      const allRowText = row.join(' ').trim();

      // Nhận diện dòng tiêu đề phân nhóm (ví dụ: "2. NHÓM SẢN PHẨM G10 (MUA 5 TẶNG 1)")
      if (/^\d+\.\s*(nhóm|chương trình)/i.test(allRowText) || /mua\s*\d+\s*tặng\s*\d+/i.test(allRowText)) {
        const mGroup = allRowText.match(/mua\s*(\d+)\s*tặng\s*(\d+)/i);
        if (mGroup) {
          currentGroupBonus = { slMua: parseInt(mGroup[1], 10), slTang: parseInt(mGroup[2], 10) };
        } else {
          currentGroupBonus = { slMua: 1, slTang: 0 };
        }
        continue;
      }

      const ten = row[colMap.ten];
      if (!ten || typeof ten !== 'string' || ten.trim().length < 2) continue;
      // Bỏ qua dòng phân nhóm
      if (/^\s*\d+\.\s*(nhóm|chương trình|sản phẩm)/i.test(ten)) continue;

      const quyCach = colMap.quyCach !== undefined ? String(row[colMap.quyCach] || 'Hộp') : 'Hộp';
      const giaRaw = colMap.gia !== undefined ? row[colMap.gia] : null;
      const giaChuaVAT = parseFloat(String(giaRaw).replace(/[^0-9.]/g, '')) || 0;
      if (giaChuaVAT <= 0) continue;

      // Đọc thuế VAT nếu có cột thuế (ví dụ 1.05 -> 5%, 1.08 -> 8%, 105% -> 5%)
      let thueVAT = 0;
      if (colMap.thue !== undefined && row[colMap.thue] !== undefined && row[colMap.thue] !== null && row[colMap.thue] !== '') {
        const rawTax = row[colMap.thue];
        let nTax = typeof rawTax === 'number' ? rawTax : parseFloat(String(rawTax).replace(/[^0-9.]/g, ''));
        if (!isNaN(nTax)) {
          if (nTax > 1 && nTax < 2) {
            thueVAT = Math.round((nTax - 1) * 100);
          } else if (nTax > 100 && nTax < 200) {
            thueVAT = Math.round(nTax - 100);
          } else if (nTax > 0 && nTax < 1) {
            thueVAT = Math.round(nTax * 100);
          } else if (nTax >= 1 && nTax <= 30) {
            thueVAT = Math.round(nTax);
          }
        }
      }

      // Giá niêm yết: Nếu có thuế thì tính thuế vào, nếu không có thuế thì là giá chưa thuế
      const giaNiemYet = thueVAT > 0 ? Math.round(giaChuaVAT * (1 + thueVAT / 100)) : giaChuaVAT;

      let slMua = currentGroupBonus.slMua;
      let slTang = currentGroupBonus.slTang;
      let ckDong = 0;

      // Kiểm tra cột KM (ví dụ '3+1' hoặc số phần trăm 0.04)
      if (colMap.km !== undefined) {
        const kmVal = String(row[colMap.km] || '').trim();
        const mBonus = kmVal.match(/(\d+)\s*\+\s*(\d+)/);
        if (mBonus) {
          slMua = parseInt(mBonus[1], 10);
          slTang = parseInt(mBonus[2], 10);
        } else if (!isNaN(parseFloat(kmVal))) {
          const n = parseFloat(kmVal);
          if (n > 0 && n < 1) ckDong = +(n * 100).toFixed(1);
          else if (n >= 1 && n <= 100) ckDong = n;
        }
      }

      sanPham.push({
        ten: ten.trim(),
        quyCach: quyCach.trim(),
        giaChuaVAT,
        thueVAT,
        giaNiemYet,
        slMua,
        slTang,
        ckDong,
      });
    }
  }

  return {
    hopLe: sanPham.length > 0,
    lyDoTuChoi: sanPham.length ? '' : 'Không trích xuất được danh sách sản phẩm nào từ file Excel này.',
    tenCT: tenCT || 'Bảng giá khuyến mãi',
    ncc: ncc || '',
    uuDaiCongBo: ckDon || null,
    ckDon,
    ckThang,
    ckQuy,
    ckThangBac: [],
    ckQuyBac: [],
    sanPham,
    khoanThem: [],
  };
}

export async function parseExcelPromotionFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const data = new Uint8Array(reader.result);
        const wb = XLSX.read(data, { type: 'array' });
        const res = parseExcelPromotionWorkbook(wb);
        resolve(res);
      } catch (e) {
        reject(new Error(`Không thể phân tích file Excel: ${e.message}`));
      }
    };
    reader.onerror = () => reject(new Error('Lỗi khi đọc file Excel'));
    reader.readAsArrayBuffer(file);
  });
}

/* ==========================================================
   BỘ ĐỌC FILE TỔNG HỢP (Excel, Word, Txt) TRÊN TRÌNH DUYỆT
   ========================================================== */
export async function readPromotionFileText(file) {
  const name = file.name.toLowerCase();

  // 1. File Excel (.xlsx, .xls, .csv)
  if (/\.(xlsx|xls|csv)$/.test(name)) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const data = new Uint8Array(reader.result);
          const wb = XLSX.read(data, { type: 'array' });
          const parts = [];
          for (const sheetName of wb.SheetNames) {
            if (/^sheet\d+$/i.test(sheetName) && wb.SheetNames.length > 1) continue;
            const ws = wb.Sheets[sheetName];
            const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
            if (!rows.length) continue;
            const cleanRows = rows
              .map((row) => (row || []).map((c) => String(c !== undefined && c !== null ? c : '').trim()))
              .filter((row) => row.some((c) => c.length > 0))
              .map((row) => {
                while (row.length && !row[row.length - 1]) row.pop();
                return row.join(' | ');
              });

            let selectedRows = cleanRows;
            if (cleanRows.length > 40) {
              selectedRows = [...cleanRows.slice(0, 35), '... (còn các dòng sản phẩm khác tiếp theo) ...'];
            }
            parts.push(`### BẢNG EXCEL: ${sheetName}\n${selectedRows.join('\n')}`);
          }
          resolve(parts.join('\n\n').slice(0, 30000));
        } catch (e) {
          reject(new Error(`Không thể phân tích file Excel: ${e.message}`));
        }
      };
      reader.onerror = () => reject(new Error('Không đọc được file Excel'));
      reader.readAsArrayBuffer(file);
    });
  }

  // 2. File Word (.docx)
  if (/\.docx$/.test(name)) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const res = await mammoth.extractRawText({ arrayBuffer: reader.result });
          resolve(String(res.value || '').slice(0, 30000));
        } catch (e) {
          reject(new Error(`Không thể trích xuất văn bản từ file Word: ${e.message}`));
        }
      };
      reader.onerror = () => reject(new Error('Không đọc được file Word'));
      reader.readAsArrayBuffer(file);
    });
  }

  // 3. File văn bản thông thường (.txt)
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || '').slice(0, 30000));
    reader.onerror = () => reject(new Error('Không đọc được file text'));
    reader.readAsText(file);
  });
}

/* ==========================================================
   BỘ BÓC TÁCH REGEX THÔNG MINH NỘI TẠI (Smart Local Fallback)
   ========================================================== */
export function smartRegexParsePromotion(text = '') {
  const lines = text.split('\n').map((l) => l.trim()).filter(Boolean);

  let tenCT = 'Chương trình bóc tách tự động';
  let ncc = '';
  let uuDaiCongBo = null;
  let ckDon = 0;
  let ckThang = 0;
  let ckQuy = 0;
  const sanPham = [];
  const khoanThem = [];

  // Tìm ưu đãi công bố (vd: "ưu đãi 30%", "giảm tới 25%")
  const congBoMatch = text.match(/(?:ưu đãi|giảm|chiết khấu)\s*(?:lên tới|tới|đến)?\s*(\d{1,2}(?:[.,]\d+)?)\s*%/i);
  if (congBoMatch) uuDaiCongBo = parseFloat(congBoMatch[1].replace(',', '.'));

  // Tìm chiết khấu đơn (vd: "ck đơn 10%", "chiết khấu hóa đơn 8%")
  const ckDonMatch = text.match(/(?:ck|chiết khấu)\s*(?:đơn|hóa đơn|thẳng|trực tiếp)[^\d]*(\d{1,2}(?:[.,]\d+)?)\s*%/i);
  if (ckDonMatch) ckDon = parseFloat(ckDonMatch[1].replace(',', '.'));

  // Tìm thưởng tháng (vd: "thưởng tháng 3%")
  const ckThangMatch = text.match(/(?:thưởng|ck)\s*(?:doanh số\s*)?tháng[^\d]*(\d{1,2}(?:[.,]\d+)?)\s*%/i);
  if (ckThangMatch) ckThang = parseFloat(ckThangMatch[1].replace(',', '.'));

  // Tìm thưởng quý (vd: "thưởng quý 2%")
  const ckQuyMatch = text.match(/(?:thưởng|ck)\s*(?:doanh số\s*)?quý[^\d]*(\d{1,2}(?:[.,]\d+)?)\s*%/i);
  if (ckQuyMatch) ckQuy = parseFloat(ckQuyMatch[1].replace(',', '.'));

  // Tìm các khoản quà tặng / du lịch / vàng / hiện kim
  if (/du lịch/i.test(text)) {
    const dlMatch = text.match(/du lịch[^\d]*(\d+(?:[.,]\d+)?)\s*(triệu|tr|trieu|000\.000)/i);
    const val = dlMatch ? (parseFloat(dlMatch[1].replace(',', '.')) * (dlMatch[2].startsWith('0') ? 1 : 1000000)) : 20000000;
    khoanThem.push({
      ten: 'Chuyến du lịch tri ân',
      maCTKM: 'CTKM17',
      giaTri: val,
      quyDoi: null,
    });
  }

  // Tặng vàng: chỉ match khi có chữ "tặng / thưởng / chỉ vàng / cây vàng", tránh match số lượng 500 viên
  if (/(?:tặng|thưởng)\s*\d+\s*(?:chỉ|cây|lượng)?\s*vàng/i.test(text) || /(?:chỉ|cây)\s*vàng\b/i.test(text)) {
    const vangMatch = text.match(/(?:tặng|thưởng)?\s*(\d+)\s*(?:chỉ|cây|lượng)?\s*vàng/i);
    const chi = vangMatch && parseInt(vangMatch[1], 10) <= 20 ? parseInt(vangMatch[1], 10) : 1;
    khoanThem.push({
      ten: `Tặng ${chi} chỉ vàng`,
      maCTKM: 'CTKM15',
      giaTri: chi * 7500000,
      quyDoi: 100,
    });
  }

  if (/kệ|posm|biển bảng/i.test(text)) {
    const keMatch = text.match(/(?:kệ|posm)[^\d]*(\d+(?:[.,]\d+)?)\s*(triệu|tr|trieu)/i);
    const val = keMatch ? parseFloat(keMatch[1].replace(',', '.')) * 1000000 : 3000000;
    khoanThem.push({
      ten: 'Hỗ trợ kệ trưng bày tại quầy',
      maCTKM: 'CTKM13',
      giaTri: val,
      quyDoi: null,
    });
  }

  // Quét các dòng sản phẩm (dạng CSV hoặc bảng text)
  for (const line of lines) {
    if (/^(STT|Mã|Tên sản phẩm|###|TRADING PORTFOLIO)/i.test(line)) continue;
    const parts = line.split(/[,\t|;]/).map((p) => p.trim().replace(/^"|"$/g, ''));
    if (parts.length >= 3) {
      // Tìm cột tên sản phẩm (chuỗi có độ dài >= 4, không phải là số thuần túy, không phải tên cột hoặc quy cách)
      const tenSp = parts.find((p) => {
        const s = String(p || '').trim();
        return (
          s.length >= 4 &&
          isNaN(Number(s)) &&
          !/^\d+[/-]\d+/.test(s) &&
          !/^(hộp|chai|vỉ|dây|gói|viên|lọ|tuýp|ống)$/i.test(s) &&
          !/^(stt|mshh|đvt|quy cách|nguyên giá|thuế|giá|km)$/i.test(s)
        );
      });

      const numbers = parts.map((p) => num(p, -1)).filter((n) => n > 0);
      if (tenSp && numbers.length >= 1) {
        const giaNiemYet = numbers.find((n) => n >= 1000) || 100000;
        const slMua = numbers.find((n) => n > 0 && n < 10000 && n !== giaNiemYet) || 1;
        const slTang = numbers.find((n) => n > 0 && n < slMua && n !== giaNiemYet) || 0;
        const quyCach = parts.find((p) => /^(hộp|chai|vỉ|dây|gói|viên|tuýp|lọ)$/i.test(p)) || 'Hộp';

        sanPham.push({
          ten: tenSp.slice(0, 100),
          quyCach,
          giaNiemYet,
          slMua,
          slTang,
          ckDong: 0,
        });
      }
    }
  }

  // Không tìm thấy sản phẩm/chiết khấu nào -> báo không hợp lệ, KHÔNG tự chèn dữ liệu mẫu giả
  if (!sanPham.length) {
    return {
      hopLe: false,
      lyDoTuChoi:
        'Không tìm thấy thông tin sản phẩm, chiết khấu hoặc khuyến mãi nào trong nội dung. Vui lòng kiểm tra lại đây có đúng là chương trình khuyến mãi (CTKM) của nhà cung cấp không.',
    };
  }

  return {
    hopLe: true,
    lyDoTuChoi: '',
    tenCT,
    ncc,
    uuDaiCongBo,
    ckDon,
    ckThang,
    ckQuy,
    ckThangBac: [],
    ckQuyBac: [],
    sanPham,
    khoanThem,
  };
}

